"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsAuditTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var ClaimsAuditTableRow_1 = require("./ClaimsAuditTableRow");
var ClaimsAuditTable = /** @class */ (function (_super) {
    __extends(ClaimsAuditTable, _super);
    function ClaimsAuditTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClaimsAuditTable.prototype.render = function () {
        return this.props.claimsAudit && this.props.claimsAudit.length > 0 && ((0, jsx_runtime_1.jsxs)("table", { className: "table table-striped table-hover table-sm", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Audit ID" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Date and Time" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Operation" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Claim ID" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Type" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Incident date" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Claim spend" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "NCD allowed" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Updated by" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderClaimsAuditTableRows() })] }));
    };
    ClaimsAuditTable.prototype.renderClaimsAuditTableRows = function () {
        var _this = this;
        return this.props.claimsAudit.map(function (claimAudit, index) {
            return (0, jsx_runtime_1.jsx)(ClaimsAuditTableRow_1.ClaimsAuditTableRow, __assign({ claimAudit: claimAudit }, _this.props), index);
        });
    };
    ClaimsAuditTable = __decorate([
        components_1.authorize
    ], ClaimsAuditTable);
    return ClaimsAuditTable;
}(React.Component));
exports.ClaimsAuditTable = ClaimsAuditTable;
//# sourceMappingURL=ClaimsAuditTable.js.map